import Vue from 'vue'
import { get } from '@/api/main'
import wx from 'weixin-js-sdk'
export default {
  beforeEach: (to, from, next) => {
    if (to.meta.useWx && to.meta.useWx === true) {
      get().then(res => {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.appId, // 必填，公众号的唯一标识
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.noncestr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名
          jsApiList: ['openLocation', 'getLocation'] // 必填，需要使用的JS接口列表
        })
      })
      wx.ready(function() {
        wx.checkJsApi({
          jsApiList: [
            'openLocation',
            'getLocation'],
          success(res) {
          }
        })
        Vue.prototype.$wx = wx
        next()
      })
    } else {
      next()
    }
  }
}
